/** Shopify CDN: Minification failed

Line 43:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 44:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 44:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 45:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 45:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 49:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 54:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 57:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 60:24 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 30:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 31:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 31:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 35:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 40:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:24 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 16:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 19:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 21:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 26:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 32:24 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');
    const { $clone } = await importModule('Utils');

    const SEL_INPUT = '[data-input]';

    customElements.define('product-qty-selector', class extends Core {
        elements = {
            selector: '[data-selector-wrapper]',
            inputTemplate: '[data-input-template]'
        }
        render() {
            this.$selector.addEventListener('change', this._onQtyChange.bind(this))
        }
        _onQtyChange(e) {
            if (+e.target.value === 10) this._changeInputType();
        }
        _changeInputType() {
            this.replaceChild($clone(this.$inputTemplate), this.$selector);
            this.querySelector(SEL_INPUT).setAttribute('value', 10);
        }        
    })
})();
